import { useTranslation } from 'next-i18next/pages';
import { useState, useEffect } from 'react';

import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';
import { useGetActiveScreenBreakpoint } from '@pflegia/ui/hooks/use-get-active-screen-breakpoint';
import { useJobListSortStore } from '@pflegia/ui/hooks/use-sort';
import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import Button from '@pflegia/ui/shared/button';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

import ClusterButton from '@shared/components/cluster-button/ClusterButton';
import { BUNDESLAND_CLUSTER, BUNDESLAND_CLUSTER_MOBILE } from '@shared/constants/homepage-clusters';

import Headline from '../headline/Headline';

const BundeslandCluster = () => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'bundeslandCluster' });
  const { setSort } = useJobListSortStore();
  const { isMobile } = useGetActiveScreenBreakpoint();
  const [isExpanded, setIsExpanded] = useState(false);
  const [bundeslandToDisplay, setBundeslandToDisplay] = useState(BUNDESLAND_CLUSTER);

  useEffect(() => {
    setBundeslandToDisplay(isMobile && !isExpanded ? BUNDESLAND_CLUSTER_MOBILE : BUNDESLAND_CLUSTER);
  }, [isMobile, isExpanded]);

  return (
    <div className='container mx-auto flex flex-col items-center'>
      <Headline
        i18nKey='landingPage:bundeslandCluster.title'
        subTitle='landingPage:bundeslandCluster.subtitle'
        showArrow
        arrowPosition='right'
      />
      <div className='flex flex-wrap justify-center'>
        {bundeslandToDisplay.map(bundesland => (
          <ClusterButton
            key={bundesland}
            label={bundesland}
            href={`${JOBS}/${normalizeJobsParams(bundesland)}`}
            onClick={() => setSort(PaginationSortField.Salary)}
            testId={`bundesland-${bundesland}`}
          />
        ))}
      </div>
      <Button
        label={isExpanded ? t('showLessButton') : t('showMoreButton')}
        colorScheme='secondary'
        className='mt-5 md:hidden'
        onClick={() => setIsExpanded(!isExpanded)}
      />
    </div>
  );
};

export default BundeslandCluster;
